/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Notes_Too_LongInputs */

const vi_form_err_notes_too_long = /** @type {(inputs: Form_Err_Notes_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú tối đa 2000 ký tự`)
};

/**

* @param {Form_Err_Notes_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_notes_too_long = /** @type {((inputs?: Form_Err_Notes_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Notes_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_notes_too_long(inputs)
});